import React from 'react'
import sample_author from "../Data/sample_images/sample_author.png"
import team_data from "../Data/about_team.json"

const TeamBlock = () => {
  return (
    <>
        <div id='#team' className="container team-container">
            <h3 className="section-subtitle">Meet</h3>
            <h1 className="section-title">Our Team</h1>
            <div className="team-box">
                {team_data.map((i) => {
                    return (
                        <div key={i.id} id={i.id} className="team-card">
                            <div className="member-img-container">
                                <img src={i.img} alt="Team Member"/>
                            </div>
                            <div className="member-info">
                                <h5 className="member-job">{i.job}</h5>
                                <div className="member-line"></div>
                                <h4 className="member-name">{i.name}</h4>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    </>
  )
}

export default TeamBlock